const buildVersion = "1.1.9";

export default buildVersion;
